import { getCurrencyFromBody } from './dom';
import { formatSectionData, formatProductData } from './utils';

export const getCustomerVariables = ({ attributes, profile: { profileInfo } = {} } = {}) => {
    const lp_cCategory = attributes?.category?.name || 'unknown';
    const lp_cStatus = profileInfo?.returningStatus || 'unknown';
    const lp_cAccountID = profileInfo?.profileID || 'unknown';

    return {
        type: 'ctmrinfo',
        info: {
            cstatus: `${lp_cCategory} : ${lp_cStatus}`,
            currency: getCurrencyFromBody(),
            customerId: lp_cAccountID
        }
    };
};

export const productDetailsCustomParams = ({ product = [], page }, customSection) => ({
    pageSdes: {
        type: 'prodView',
        currency: page?.attributes?.currency?.toUpperCase(),
        products: formatProductData(product, 'productID')
    },
    sectionData: formatSectionData(page, customSection)
});

export const basketCustomParams = ({ cart = {}, page }, customSection) => ({
    pageSdes: {
        type: 'cart',
        total: cart.total?.basePrice,
        currency: cart.total?.currency?.toUpperCase(),
        numItems: cart.attributes?.quantity,
        products: formatProductData(cart.item)
    },
    sectionData: formatSectionData(page, customSection)
});

export const orderConfCustomParams = ({ transaction = {}, page }, customSection) => ({
    pageSdes: {
        type: 'purchase',
        total: transaction.total?.basePrice,
        orderId: transaction.transactionID,
        currency: transaction.total?.currency?.toUpperCase(),
        cart: {
            products: formatProductData(transaction.item)
        }
    },
    sectionData: formatSectionData(page, customSection)
});
